/**
 * Leadership chart accents — one distinct hue per status so stacked bars stay readable.
 */
const LEADERSHIP_STATUS_QUEUE_COLORS = {
  Active: '#0f766e',
  'Sales Cycle': '#7c3aed',
  'Go-Live Complete': '#2563eb',
  Completed: '#16a34a',
  'Info Requested': '#0891b2',
  'At Risk': '#dc2626',
  'Needs Review': '#ea580c',
  Cancelled: '#94a3b8',
  'Project On Hold': '#ca8a04',
  Unknown: '#78716c',
  // BMC FY quarters (April start)
  Q1: '#4040d9',
  Q2: '#914796',
  Q3: '#264580',
  Q4: '#d6392b',
};

const FALLBACK_COLORS = [
  '#db2777',
  '#4f46e5',
  '#0d9488',
  '#b45309',
  '#65a30d',
  '#be123c',
  '#475569',
  '#c026d3',
];

const hashStatusKey = (status) => {
  const text = String(status || '');
  let hash = 0;
  for (let i = 0; i < text.length; i += 1) {
    hash = ((hash << 5) - hash) + text.charCodeAt(i);
    hash |= 0;
  }
  return Math.abs(hash);
};

export const getLeadershipChartBarColor = (status) => (
  LEADERSHIP_STATUS_QUEUE_COLORS[status]
  || FALLBACK_COLORS[hashStatusKey(status) % FALLBACK_COLORS.length]
);

export const getLeadershipChartLegendColor = getLeadershipChartBarColor;

export const LEADERSHIP_STATUS_COLORS = { ...LEADERSHIP_STATUS_QUEUE_COLORS };
